import request from '@/utils/request'

/**
 * 获取集采订单列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listChainInoutOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainInoutOrder.listChainInoutOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取供应商列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listChainSuppliers(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplier.listChainSupplier',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}